export const DEFAULT_ZOOM_LEVEL: number = 3;
export const DEFAULT_MAX_ZOOM_LEVEL: number = 21;
export const DEFAULT_MIN_ZOOM_LEVEL: number = 1;
export const MAX_MACHINES_NUMBERS_FOR_POLLING: number = 100;
export const EUROPE_GEOGRAPHICAL_CENTER_COORDINATES = {lat: 54.90673906228113, lng: 25.320402000937147};
export const GOOGLE_MAPS_DIRECTION_URL = 'https://maps.google.com/maps/dir/';
export const GOOGLE_MAP_STYLES:  google.maps.MapTypeStyle[] = [
  {
    featureType: 'landscape.man_made',
    elementType: 'geometry',
    stylers: [
      {
        'color': '#f7f1df'
      }
    ],
  },
  {
    featureType: 'landscape.natural',
    elementType: 'geometry',
    stylers: [
      {
        'color': '#d0e3b4'
      }
    ],
  },
  {
    featureType: 'landscape.natural.terrain',
    elementType: 'geometry',
    stylers: [
      {
        'visibility': 'off'
      }
    ],
  },
  {
    featureType: 'poi',
    elementType: 'labels',
    stylers: [
      {
        'visibility': 'off'
      }
    ],
  },
  {
    featureType: 'poi.business',
    elementType: 'all',
    stylers: [
      {
        'visibility': 'off'
      }
    ],
  },
  {
    featureType: 'poi.medical',
    elementType: 'geometry',
    stylers: [
      {
        'color': '#fbd3da'
      }
    ],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [
      {
        'color': '#bde6ab'
      }
    ],
  },
  {
    featureType: 'road',
    elementType: 'geometry.stroke',
    stylers: [
      {
        'visibility': 'off'
      }
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels',
    stylers: [
      {
        'visibility': 'off'
      }
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [
      {
        'color': '#ffe15f'
      }
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [
      {
        'color': '#efd151'
      }
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry.fill',
    stylers: [
      {
        'color': '#ffffff'
      }
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'geometry.fill',
    stylers: [
      {
        'color': 'black'
      }
    ],
  },
  {
    featureType: 'transit.station.airport',
    elementType: 'geometry.fill',
    stylers: [
      {
        'color': '#cfb2db'
      }
    ],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [
      {
        'color': '#a2daf2',
      }
    ],
  }
];
